import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import type { UnhighlightEdgeEvent } from 'components/Graph/model/GraphCommandEvents';

export type UnhighlightEdgeCommand = UnhighlightEdgeEvent;

export const unhighlightEdge: GraphCommandFactory<UnhighlightEdgeCommand> =
  (cmdContext) => (command) => {
    cmdContext.eventEmitter.emit('unhighlightEdge', command);
  };
